var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-coverImage",class:{
    'is-fixed': _vm.isFixed,
    'is-scaled': _vm.isScaled,
  },style:({
    width: (_vm.width + "px"),
    height: (_vm.height + "px"),
    top: (_vm.top + "px"),
    left: (_vm.left + "px"),
  })},[_c('div',{ref:"image",staticClass:"p-coverImage__image",style:({
    'background-image': ("url(" + _vm.src + ")")
  })}),_vm._v(" "),_c('div',{staticClass:"p-coverImage__name"},_vm._l((_vm.dest_name),function(letter,i){return _c('span',{style:({
        'transition-delay': ((i / 10) + "s")
      }),on:{"transitionend":function($event){_vm.onTransitionendLetter(i)}}},[_vm._v(_vm._s(letter))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d31768","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partial/cover-image.vue
// module id = null
// module chunks = 